import React from 'react';
import Item from './Item';
import styles from './plans.module.scss';



export function PlansRadio(props) {
  const { plans, onChange, title } = props;
  return (
    <div className={styles['container']}>
      {plans.length ? (
        <h2 className={styles['section-title']}>{title?title:"Select installments plan"}</h2>
      ) : (
        ''
      )}
      <form className={styles['radio-form']}>
        {plans.map((item) => {
          return <Item key={item.id} data={item} handleClick={onChange} />;
        })}
      </form>
    </div>
  );
}

export default PlansRadio;
